"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidateAccessToken = invalidateAccessToken;
exports.setExpiryTimeout = setExpiryTimeout;
exports.isExpired = isExpired;
var jwt_decode_1 = require("jwt-decode");
var constants_1 = require("../constants");
var localStorageHelper = __importStar(require("./localStorageHelper"));
function invalidateAccessToken() {
    localStorageHelper.removeAccessToken();
}
function setExpiryTimeout(accessToken) {
    var expiryTimestampInMilliseconds = accessToken.expiryTimestamp * 1000;
    setTimeout(invalidateAccessToken, expiryTimestampInMilliseconds);
}
function isExpired(accessToken) {
    try {
        var decodedToken = (0, jwt_decode_1.jwtDecode)(accessToken.jwt);
        var expiryEpochInMilliseconds = (decodedToken.exp || 0) * 1000;
        return expiryEpochInMilliseconds - constants_1.MS_REFRESH_TOKEN_BEFORE_EXPIRY < Date.now();
    }
    catch (_a) {
        return true;
    }
}
//# sourceMappingURL=tokenExpirationHelper.js.map